"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _simpleConfig = require("@/api/simpleConfig");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SimpleConfig',
  data: function data() {
    return {
      loading: false,
      submitLoading: false,
      tableData: [],
      total: 0,
      page: {
        pageNum: 1,
        pageSize: 20
      },
      searchForm: {
        configName: '',
        status: null
      },
      dialogVisible: false,
      dialogTitle: '',
      isEdit: false,
      formData: {
        id: null,
        configName: '',
        configValue: '',
        configDesc: '',
        status: 0
      },
      formRules: {
        configName: [{
          required: true,
          message: '请输入配置名称',
          trigger: 'blur'
        }, {
          pattern: /^[a-zA-Z0-9_]+$/,
          message: '只能包含字母、数字和下划线',
          trigger: 'blur'
        }],
        configValue: [{
          required: true,
          message: '请输入配置值',
          trigger: 'blur'
        }],
        status: [{
          required: true,
          message: '请选择状态',
          trigger: 'change'
        }]
      }
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    /**
     * 获取列表数据
     */
    getList: function getList() {
      var _this = this;
      this.loading = true;
      var params = {
        page: this.page.pageNum,
        limit: this.page.pageSize,
        configName: this.searchForm.configName || undefined,
        status: this.searchForm.status !== null && this.searchForm.status !== '' ? this.searchForm.status : undefined
      };
      (0, _simpleConfig.simpleConfigList)(params).then(function (res) {
        _this.tableData = res.data.list || [];
        _this.total = res.data.total || 0;
        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    },
    /**
     * 搜索
     */
    handleSearch: function handleSearch() {
      this.page.pageNum = 1;
      this.getList();
    },
    /**
     * 重置搜索条件
     */
    handleReset: function handleReset() {
      this.searchForm = {
        configName: '',
        status: null
      };
      this.page.pageNum = 1;
      this.getList();
    },
    /**
     * 刷新
     */
    handleRefresh: function handleRefresh() {
      this.getList();
    },
    /**
     * 编辑配置
     */
    handleEdit: function handleEdit(row) {
      this.isEdit = true;
      this.dialogTitle = '编辑配置';
      this.formData = {
        id: row.id,
        configName: row.configName,
        configValue: row.configValue,
        configDesc: row.configDesc,
        status: row.status
      };
      this.dialogVisible = true;
    },
    /**
     * 提交表单
     */
    handleSubmit: function handleSubmit() {
      var _this2 = this;
      this.$refs.form.validate(function (valid) {
        if (!valid) {
          return false;
        }
        _this2.submitLoading = true;
        (0, _simpleConfig.simpleConfigSaveOrUpdate)(_this2.formData).then(function (res) {
          _this2.$message.success('保存成功');
          _this2.dialogVisible = false;
          _this2.getList();
          _this2.submitLoading = false;
        }).catch(function () {
          _this2.submitLoading = false;
        });
      });
    },
    /**
     * 分页 - 每页条数变化
     */
    handleSizeChange: function handleSizeChange(val) {
      this.page.pageSize = val;
      this.page.pageNum = 1;
      this.getList();
    },
    /**
     * 分页 - 当前页变化
     */
    handleCurrentChange: function handleCurrentChange(val) {
      this.page.pageNum = val;
      this.getList();
    }
  }
};